export default __webpack_public_path__ + "static/media/juni.c6396732.webp";